import CryptoJS from 'crypto-js';
const getShortForm = (fullName) => {
    if (!fullName) return "";
    const words = fullName.split(" ");
    var spLength = words.length;
    var str = '';
    if(spLength >= 2){
        str = words[0].charAt(0).concat(words[spLength-1].charAt(0));
    }
    else if(spLength == 2){
        str = words[0].charAt(0).concat(words[1].charAt(0));
    }
    else{
        str = words[0].charAt(0).concat(words[0].charAt(1));
    }
    return str.toUpperCase();
}
const ValidateEmail = (email) => {
    if (!email) return "";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
const specialCharacterValidate = (inputVal) => {
    return inputVal.replace(/[^a-zA-Z0-9_ ]/g, '').replace(/ /g, '_');
}
const getLocalStrogeValue = (param) => {
    const localStorageValue = localStorage.getItem(param);
    return localStorageValue
}
const base64Encode = (input) => {
    return btoa(input);
}
const base64Decode = (input) => {
    return atob(input);
}
const formatDate = (dateString) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: timeZone
    }).format(date);
}
const safeDecrypt = (param) => {
    const { encryptedData, base64Key, base64Iv } = param;
    try {
        const key = CryptoJS.enc.Utf8.parse(base64Key);
        const iv = CryptoJS.enc.Utf8.parse(base64Iv);
        const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const plaintext = decrypted.toString(CryptoJS.enc.Utf8);
        if (!plaintext || plaintext.trim() === "") {
            throw new Error("Decryption failed: invalid key or corrupted data");
        }
        return plaintext;
    } catch (err) {
        console.error("Error while decrypting:", err.message);
        return null;
    }
}
const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 2) {
        return parts[0]; // "subdomain"
    }
    return null; // No subdomain
};
const timeZoneDateFormat = (dateParam) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const inputDate = new Date(dateParam);
    const options = {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: timeZone
    };
    const formattedDate = inputDate.toLocaleString("en-GB", options).replace(",", " at");
    return formattedDate;
};
const timezoneOffset = () => {
    const offset = -new Date().getTimezoneOffset();
    const hours = String(Math.floor(offset / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offset % 60)).padStart(2, '0');
    const offsetStr = `${offset >= 0 ? '+' : '-'}${hours}:${minutes}`;
    return offsetStr
};
const newTimezoneOffset = () => {
    const offset = -new Date().getTimezoneOffset();
    const retOffset = Number(`${offset >= 0 ? '-' : '+'}${offset}`);
    return retOffset
};
const refreshCaptcha = async() => {
    const SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha) return reject('grecaptcha not loaded');
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute( SITE_KEY , {action : 'submit'} )
            .then(resolve)
            .catch(reject);
        });
    });
};
const spDateRange = (dateRange) => {
    if (!dateRange) return "";
    const startDate = new Date( dateRange[0]).toLocaleString("en-GB");
    const endDate = new Date( dateRange[1]).toLocaleString("en-GB");
    var spStartDate = startDate.split(", ");
    var spEndDate = endDate.split(", ");
    const [s_day, s_month, s_year] = spStartDate[0].split('/');
    const [e_day, e_month, e_year] = spEndDate[0].split('/');
    const retObj = {
        startDate : `${s_year}-${s_month}-${s_day}`,
        endDate : `${e_year}-${e_month}-${e_day}`,
    }
    return retObj
}
export {
    getShortForm, 
    ValidateEmail, 
    getLocalStrogeValue,
    base64Encode,
    base64Decode,
    specialCharacterValidate,
    formatDate,
    safeDecrypt,
    getSubdomain,
    timeZoneDateFormat,
    timezoneOffset,
    newTimezoneOffset,
    refreshCaptcha,
    spDateRange
}